import React, { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Collapse, Card, Divider } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import {
  Cached as CachedIcon,
  PersonPinCircle as PushPinIcon,
  ExpandLessRounded as UpIcon,
  ExpandMoreRounded as DownIcon,
} from '@material-ui/icons'

import DateTime from 'luxon/src/datetime.js'

import { isArray, isObject, typeOf } from '../../../utils/customMethods'
import Typography from '../../atoms/display/typography'
import EscapeDrag from '../../molecules/display/escapeDrag'
import useStyles from './TransferHistoryStyle'

const TransferHistory = (props) => {
  const classes = useStyles()
  const theme = useTheme()

  const { t } = useTranslation()

  const generalInformation = useSelector((state) => state.generalInformation)
  const [expanded, setExpanded] = useState({
    0: false,
  })
  const regex =
    /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}[A-Z]{1}/

  const handleCollapse = useCallback((index) => {
    setExpanded((expanded) => ({
      ...expanded,
      [index]: !expanded[index],
    }))
  }, [])

  const formatDate = (value) => {
    const date = new Date(value)
    const format = `D '-' t`
    const time = DateTime.fromJSDate(date).setLocale('pt-br').toFormat(format)

    return isNaN(date.getTime()) ? value : time
  }

  const formatString = ([key, value]) => {
    if (regex.test(value)) {
      return formatDate(value)
    }

    if (key === 'label') {
      value = value.replace('Transf. ', '')
      return t(`transferHistoryChildrens.${value}`)
    }

    return value
  }

  const renderItems = () => {
    const block = ['departmentId', 'consumerId', 'userId', 'skillId', 'type']
    const chatId = props?.chatId
    const data = generalInformation.conversations[chatId]?.transferHistory

    return isArray(data) && data.length > 0 ? (
      data.map((e, key) => (
        <Card className={classes.transferredItem}>
          <Typography variant="body1">
          {e?.type === 'assignment' ? <PushPinIcon className={classes.transferIcon} fontSize="small"/> : <CachedIcon className={classes.transferIcon} fontSize="small"/>}
            {t(`transferHistoryChildrens.${e.type ? e.type : 'transfer'}`)}
          </Typography>
          <Divider className={classes.divider}/>
          {isObject(e) &&
            Object.entries(e).map(
              (item, idx) =>
                item[1] &&
                !block.find((blk) => blk === item[0]) && (
                  <div key={idx}>
                    <Typography variant="body1">
                     
                        {t(`transferHistoryChildrens.${item[0]}`)}:
               
                    </Typography>
                    <Typography variant="body1">
                      <EscapeDrag>
                        {typeOf(item[1], 'string') && formatString(item)}
                      </EscapeDrag>
                    </Typography>
                  </div>
                )
            )}
        </Card>
      ))
    ) : (
      <div className={classes.emptySpace}>{t('items.notfound')}</div>
    )
  }

  const renderContent = () => {
    return (
      <>
        <div className={classes.menuBar} onClick={() => handleCollapse(0)}>
          <Typography variant="body1">
            {t('commons.transferHistory')}
          </Typography>
          <div className={classes.arrowContent}>
            {expanded[0] ? <UpIcon /> : <DownIcon />}
          </div>
        </div>
        <Collapse in={expanded[0]} timeout="auto" unmountOnExit>
          <div className={classes.content}>{renderItems()}</div>
        </Collapse>
      </>
    )
  }

  return renderContent()
}

export default TransferHistory
